import { render, staticRenderFns } from "./edit-payment-gateway-form.vue?vue&type=template&id=35050726&"
import script from "./edit-payment-gateway-form.vue?vue&type=script&lang=js&"
export * from "./edit-payment-gateway-form.vue?vue&type=script&lang=js&"
import style0 from "./edit-payment-gateway-form.vue?vue&type=style&index=0&id=35050726&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports